import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Snackbar,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { Colors } from "helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import { SyntheticEvent, useState } from "react";
import { ITableCallParams } from "types/Tables";
import { useSearchParams } from "react-router-dom";
import { useMutationAddTableCall } from "services/api/mutations/useMutationAddTableCall";
import Typography from "@mui/material/Typography";
import useTable from "../../components/useTable";
import { useSelector } from "react-redux";
import { ICardapioAppState } from "../../redux/RootReducer";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";

type Props = {
  open: boolean; handleClose: () => void; openSnackBarTableCall: () => void;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

function TableCallDialog({ open, handleClose, openSnackBarTableCall, shoppingBagQuery }: Props) {

  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const { table_number, existingTables, isLoadingExistingTables, alterTableNumber } = useTable({shoppingBagQuery});
  const [disabledChamarGarcom, setDisabledChamarGarcom] = useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const placeId = searchParams.get("place_id");
  const { mutate: newTableCall } = useMutationAddTableCall();
  const formik = useFormik({
    initialValues: {
      table_number: Number(table_number),
    }, enableReinitialize: true, onSubmit: async (values: any) => {
      try {
        const procurado = existingTables.filter((v: string) => Number(v) === values.table_number);
        if (procurado.length < 1) {

          // resetando o valor do form
          values.table_number = Number(table_number);

          setMensagem("Mesa não encontrada.");
          setOpenSnackBar(true);
          return;
        }

        setMensagem("Garçom chamado.");
        setOpenSnackBar(true);
        formik.setSubmitting(false);
        openSnackBarTableCall();

        setDisabledChamarGarcom(true);
        setTimeout(() => {
          setDisabledChamarGarcom(false);
        }, 90000);
        const tableCallParams = {
          calling: true, place_id: Number.parseInt(placeId!), table_number: values.table_number,
        } as ITableCallParams;
        newTableCall(tableCallParams);

        await alterTableNumber(values.table_number);
        resetValues();
      } finally {
        handleClose();
      }
    },
  });

  const handleCloseSnackBar = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  function resetValues() {
    formik.values.table_number = Number(table_number);
  }

  return (<>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="error"
          sx={{ width: "100%" }}
        >
          <p>{mensagem}</p>
        </Alert>
      </Snackbar>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => {
          handleClose();
          resetValues();
        }}
        maxWidth={"lg"}
      >
        <DialogTitle color={Colors.orangePrimary}>
          <Box display="flex" alignItems="center">
            <Box>
              <IconButton
                color="primary"
                onClick={() => {
                  handleClose();
                  resetValues();
                }}
              >
                <ArrowBackIosIcon fill={Colors.orangePrimary} />
              </IconButton>
            </Box>

            {!loginInfo && (<>
              <Box
                flexGrow={1}
                sx={{
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                Chamar Garçom
              </Box>
            </>)}

            {loginInfo && (<>
              <Box
                flexGrow={1}
                sx={{
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                Qual mesa você está?
              </Box>
            </>)}
          </Box>
        </DialogTitle>
        <DialogContent>


          {!(!isLoadingExistingTables && loginInfo) && (<>
            <Paper sx={{
              padding: "10px",
              display:"flex",
              justifyContent: "center",
              alignItems: "center"}}>
              <CircularProgress /> <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>  Aguarde, carregando números de mesas...
            </Paper>

          </>)}

          {!isLoadingExistingTables && loginInfo && (<form noValidate onSubmit={formik.handleSubmit}>
            <Box>
              <TextField
                value={formik.values.table_number}
                onChange={formik.handleChange}
                type="number"

                placeholder="Qual a mesa que você está?"
                label="Qual a mesa que você está?"
                name="table_number"
                sx={{
                  WebkitAppearance: "none", MozAppearance: "none", appearance: "none",
                }}
                variant="standard"
                fullWidth
              />
            </Box>
            <Box display={"flex"} flexGrow={1}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={disabledChamarGarcom || (formik.values.table_number <= 0)}
                sx={{ color: "white", marginTop: "15px", width: "50%" }}
              >
                Confirmar
              </Button>
              <Button
                color="primary"
                variant="outlined"
                sx={{ marginTop: "15px", width: "50%", marginLeft: 2 }}
                onClick={() => {
                  handleClose();
                  resetValues();
                }}
              >
                Cancelar
              </Button>
            </Box>
            {disabledChamarGarcom && (<Box
                display={"flex"}
                sx={{
                  alignItems: "center", justifyContent: "center", marginTop: 2,
                }}
              >
                <Typography
                  fontSize={12}
                  fontWeight={700}
                  color={Colors.orangePrimary}
                >
                  O garçom foi chamado a menos de 2 minutos.
                </Typography>
              </Box>)}
          </form>)}
        </DialogContent>
      </Dialog>
    </>);
}

export default TableCallDialog;
